import React, { useState } from 'react'

import connect from 'src/redux/connect'
import { Icon } from 'src/chrome'
import MenuItem, { MenuItemType } from 'src/chrome/HelpMenu/MenuItem'

import styles from './helpmenu.module.scss'

window.intercomSettings = {
  vertical_padding: 70,
}
interface HelpMenuProps {
  tourId: string | undefined
}

const HelpMenu: React.FC<HelpMenuProps> = props => {
  const [open, toggleOpen] = useState<boolean>(false)

  const toggleMenu = () => {
    toggleOpen(open => !open)
    closeIntercom()
  }

  const closeIntercom = () => {
    if (window.Intercom) {
      window.Intercom('hide')
    }
  }

  const launchIntercom = () => {
    if (window.Intercom) {
      window.Intercom('show')
    } else {
      console.log(
        'Intercom Does not exist on the window, please check your intercom config script',
      )
    }
  }

  const launchTips = () => {
    window.Appcues.show(props.tourId)
  }

  const items: MenuItemType[] = [
    {
      title: 'Privacy',
      icon: {
        icon: 'COG',
        color: '#333',
        size: 17,
        viewBox: '0 0 1024 1154',
      },
      link:
        'http://help.sendoutcards.com/en/articles/3603758-california-consumer-privacy-act-ccpa',
    },
    {
      title: 'Help',
      icon: {
        icon: 'LIST',
        color: '#333',
        size: 18,
      },
      link: 'https://help.sendoutcards.com',
    },
    {
      title: 'Message',
      onClick: launchIntercom,
      icon: {
        icon: 'CHAT',
        color: '#333',
        size: 18,
        viewBox: '0 0 1024 1154',
      },
    },
    {
      title: 'Tips',
      onClick: launchTips,
      disabled: !props.tourId,
      icon: {
        icon: 'INFO',
        color: '#333',
        size: 18,
      },
    },
  ]
  return (
    <div
      className={
        open ? `${styles.floatingMenu} ${styles.open}` : styles.floatingMenu
      }
    >
      <div className={styles.menuItems}>
        {items.map((item: MenuItemType, index: number) => {
          return item.disabled ? null : <MenuItem key={index} item={item} />
        })}
      </div>
      <div className={styles.mainButton} onClick={toggleMenu}>
        <Icon
          icon={open ? 'CLOSE' : 'QUESTIONMARK'}
          color={'#FFF'}
          size={20}
          viewBox={open ? '' : '0 0 22 32'}
          centered={true}
        />
        <p>{open ? 'close' : 'Help'}</p>
      </div>
    </div>
  )
}

export default connect(state => ({
  ...state.helpmenu,
}))(HelpMenu)
